import React from 'react';
import { InformationItemsArea } from './styles';

export function InformationsItems({
  icon,
  title,
  description,
  noIconBorder,
  imgWidth,
}: InformationsItemsProps) {
  return (
    <InformationItemsArea
      data-testid="information-items-area-main-area"
      imgWidth={imgWidth}
      hasDescription={!!description}
    >
      <div className="header">
        <div
          className={noIconBorder ? 'img-area' : 'img-area border'}
          data-testid="information-items-area-image-area"
        >
          <img src={icon} alt="icon" data-testid="information-items-area-icon" />
        </div>
        <span data-testid="information-items-area-text">{title}</span>
      </div>
      {description && (
        <span data-testid="information-items-area-description" className="description">
          {description}
        </span>
      )}
    </InformationItemsArea>
  );
}

interface InformationsItemsProps {
  icon: string;
  title: string;
  description?: string;
  noIconBorder?: boolean;
  imgWidth?: string;
}
